import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

import { IAttachment } from 'app/request-form/_models/attachment.interface';
import { MessageItemViewModel } from 'app/request-form/_models/message-item.view-model';

@Component({
  selector: 'app-message-item',
  templateUrl: './message-item.component.html',
  styleUrls: ['./message-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MessageItemComponent  {
  @Input() viewModel: MessageItemViewModel;
  @Output() clickItem = new EventEmitter<IAttachment>();

  private readonly router = inject(Router);

  /**
   * Method called when attachment is clicked to download
   * @param attachment attachment clicked from attachment list
   */
  clickAttachment(attachment: IAttachment): void {
    this.clickItem.emit(attachment);
  }

  clickLink(submitted_form_id: string): void {
    this.router.navigateByUrl(`/request/solicitation/detail/${submitted_form_id}`);
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }
}
